module.exports = __webpack_public_path__ + "img/palm2_10.34bab949.png";